import { TransportScope } from "../../../../common/model/transport.model";
import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ComponentSelectionStorageService } from '@sdbn/common';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup } from '@angular/forms';
import { AppClientConfigurationService } from '@sdbn/common';
import { Observable } from 'rxjs';
import { AppServerAPI } from '@sdbn/common';

export interface GcCaseDialogData {
  qrCodeUrl: string;
  carrier: string;
  name: string;
  identifier: string;
  transportScope: TransportScope;
  transportId: number;
}

const GC_CASE_DIALOG_UPDATE_DISPLAY_AUTOMATICALLY = 'gc.case-dialog.update-display-automatically';

@Component({
    selector: 'app-gc-case-dialog',
    templateUrl: './gc-case-dialog.component.html',
    styleUrls: ['./gc-case-dialog.component.scss'],
    standalone: false
})
export class GcCaseDialogComponent {


  dynamicDisplayEnabled = false;

  updateDisplayAutomatically = false;

  detailsFormGroup = new FormGroup({});

  constructor(
    public dialogRef: MatDialogRef<GcCaseDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: GcCaseDialogData,
    private componentSelectionStorageService: ComponentSelectionStorageService,
    private configurationService: AppClientConfigurationService,
    private appServerAPI: AppServerAPI
  ) {

    this.dynamicDisplayEnabled = this.configurationService.getPropertyValue('display.gc-connection.display-key', null) != null &&
      configurationService.getPropertyValue('display.gc-connection.display-key', null).length > 0;

    const stored = this.componentSelectionStorageService.get(GC_CASE_DIALOG_UPDATE_DISPLAY_AUTOMATICALLY);
    if (stored != null) {
      this.updateDisplayAutomatically = stored;
    }

    this.detailsFormGroup.addControl('updateDisplayAutomatically', new FormControl(this.updateDisplayAutomatically, []));

    if (this.dynamicDisplayEnabled) {
      this.detailsFormGroup.valueChanges.subscribe(values => {
        if (this.detailsFormGroup.dirty) {
          this.updateDisplayAutomatically = this.detailsFormGroup.controls.updateDisplayAutomatically.value;
          this.componentSelectionStorageService.save(GC_CASE_DIALOG_UPDATE_DISPLAY_AUTOMATICALLY, this.updateDisplayAutomatically);
          if (this.updateDisplayAutomatically) {
            this.activateGlobalConnectDisplay();
          }
        }
      }
      );
    }

    if (this.updateDisplayAutomatically) {
      this.activateGlobalConnectDisplay();
    }
  }

  public activateGlobalConnectDisplayAction() {
    this.activateGlobalConnectDisplay();
  }

  private activateGlobalConnectDisplay() {
    if (this.dynamicDisplayEnabled) {
      this.performActivation(this.data.transportId).subscribe(response => {
        console.log('Activate GlobalConnect display succeeded', response);
      });
    }
  }

  public performActivation(transportId: number): Observable<any> {
    const url = `/client/displays/activate-gc`;
    return this.appServerAPI.execute<any>(url, transportId);
  }
}
